'use strict';

Page.Bsl = new Class({
	Extends: Page,
	build: function build() {
		this.parent();
		this.get_stalker_info();
		this.fill_nav_title();
		this.set_sales_data();
		this.set_available_apts();
		this.set_similar_buildings();
		//this.set_floorplans();
		this.set_all_units();
		this.set_sell();
		this.set_contact();
		this.set_off_market_deals();

		//this.add_alert_link();
		var _review_link = document.getElement('#blimp-review-building');

		if (_review_link) new Blimp.Form(_review_link, {
			draggable: true
		});

		this.add_save_link();
		this.add_send_link();
		this.add_share_link();
		this.show_top_nav_contact();
		this.building_stalker_data();
	},
	building_stalker_data: function building_stalker_data() {
		var _info = document.getElement('.stalker_info');
		var building_stalker = document.getElement('.persist_nav.building');
		var building_name = _info.getElement('input[name="build_name"]').value;
		var building_address = _info.getElement('input[name="build_address"]').value;

		// Doorman?
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;

		// Sales history removal
		var is_sales_history = _info.getElement('input[name="is_sales_history"]').value;
		if (!is_sales_history) {
			building_stalker.getElement('.sale-history').remove();
		}

		// Ratings removal
		var is_ratings = _info.getElement('input[name="is_ratings"]').value;
		if (!is_ratings) {
			building_stalker.getElement('.ratings').remove();
		}

		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		if (building_name) {
			building_stalker.getElement('.title').set('text', building_name + ', ' + building_address);
		} else {
			building_stalker.getElement('.title').set('text', building_address);
		}
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		var apts_sale = document.getElement('input[name="apts_sale"]').value;
		var apts_rent = document.getElement('input[name="apts_rent"]').value;
		var apts_num = apts_sale + apts_rent;
	},
	show_top_nav_contact: function show_top_nav_contact() {
		var buttonContact = document.getElement('[data-popup-name="contact-popup"');
		var buttonContactTopNav = document.getElement('.button-contact-top');
		if (buttonContact && buttonContactTopNav) {
			buttonContactTopNav.removeClass('none');
		}
	},

	add_alert_link: function add_alert_link() {
		var _alertButton = document.getElement('.alert-button-container .building-alert');
		this._stalker_alert_link = document.getElement('.w_stalker .persist_nav.building .links-icons');
		if (this._stalker_alert_link && _alertButton) {
			_alertButton.inject(this._stalker_alert_link);
		}
	},

	add_save_link: function add_save_link() {
		var _alertButton = document.querySelector('.alert-button-container .building-alert2');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _alertButton) {
			var clonedAlertButton = _alertButton.cloneNode(true);
			this._stalker_alert_link.appendChild(clonedAlertButton);
		}
	},

	add_share_link: function add_share_link() {
		var _shareButton = document.querySelector('.alert-button-container .link-icon.email');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _shareButton) {
			var clonedShareButton = _shareButton.cloneNode(true);
			this._stalker_alert_link.appendChild(clonedShareButton);
		}
	},

	add_send_link: function add_send_link() {
		var self = this;
		var _sendButton = document.getElement('.send-button-container .send-button');
		this._stalker_send_link = document.getElement('.w_stalker .persist_nav_new .links-icons');
		if (this._stalker_send_link && _sendButton) {
			_sendButton.clone().inject(this._stalker_send_link);
		}
	},
	get_stalker_info: function get_stalker_info() {
		var _info = document.getElement('.stalker_info');

		this.apt_sale = _info.getElement('input[name=apts_sale]').get("value");
		this.apt_sale_url = _info.getElement('input[name=apts_sale_url]').get("value");
		this.apt_rent = _info.getElement('input[name=apts_rent]').get("value");
		this.build_name = _info.getElement('input[name=build_name]').get("value");
		this.build_address = _info.getElement('input[name=build_address]').get("value");
		this.build_type = _info.getElement('input[name=build_type]').get("value").capitalize();
		this.build_predev_concept = _info.getElement('input[name=build_predev_concept]').get("value");
		this.map_link = _info.getElement('input[name=map_link]').get("value");
		this.map_name = _info.getElement('input[name=map_name]').get("value");
		this.all_units_url = _info.getElement('input[name=all_units_url]').get("value");
		this.similar_buildings_url = _info.getElement('input[name=similar_buildings_url]').get("value");
		this.sales_history_url = _info.getElement('input[name=sales_history_url]').get("value");
		this.is_sales_history = _info.getElement('input[name=is_sales_history]').get("value");
		this.floorplans_url = _info.getElement('input[name=floorplans_url]') ? _info.getElement('input[name=floorplans_url]').get("value") : '';
		this.sell_url = _info.getElement('input[name=sell_url]') ? _info.getElement('input[name=sell_url]').get("value") : '';
		this.building_total_units = _info.getElement('input[name=building_total_units]') ? _info.getElement('input[name=building_total_units]').get("value") : '0';
	},

	// fill_nav_title: function(){
	// 	var _stalker_title = document.getElement('.w_stalker .nav_title');

	// 	if(!_stalker_title) {
	// 		return;
	// 	}

	// 	var _stalker_build_name = _stalker_title.getElement('._name');
	// 	var _stalker_build_type = _stalker_title.getElement('._type');
	// 	var _stalker_map_link = _stalker_title.getElement('._map');

	// 	var name = '';
	// 	// add building name
	// 	if (this.build_name) {
	// 		name += this.build_name;
	// 	}
	// 	// add adress name
	// 	if (this.build_address) {
	// 		if (name) {
	// 			name += ', ';
	// 		}
	// 		name += this.build_address;
	// 	}
	// 	// add generic label
	// 	if (name) {
	// 		name += ', ';
	// 	}
	// 	name += 'Comments';


	// 	let buildingTypeAndHood;
	// 	if (this.build_type != '' ) {
	// 		buildingTypeAndHood = this.build_type;
	// 	}
	// 	if (this.map_name != '') {
	// 		if (this.build_type != '' ) {
	// 			buildingTypeAndHood += ' in ';
	// 		}
	// 		buildingTypeAndHood += this.map_name;
	// 	}
	// 	_stalker_build_type.set('text', buildingTypeAndHood);
	// }

	fill_nav_title: function fill_nav_title() {
		var _stalker_title = document.getElement('.w_stalker .nav_title');

		var building_stalker = document.getElement('.persist_nav.building');
		var _info = document.getElement('.stalker_info');
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;
		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		// links
		var navItems = document.querySelectorAll('.building_nav ul li');
		var bldgFullUrl = document.querySelector('input[name="bldg_full_url"]').value;

		navItems.forEach(function (item) {
			item.addEventListener('click', function () {
				var targetId = this.getAttribute('data-target');
				if (targetId) {
					var fullUrlWithHash = bldgFullUrl + '#' + targetId;
					// redirect to hash
					window.location.href = fullUrlWithHash;
				}
			});
		});

		if (!_stalker_title) {
			return;
		}

		var _stalker_info = _stalker_title.getElement('._info');
		var _stalker_build_type = _stalker_title.getElement('._type');
		// var _stalker_map_link = _stalker_title.getElement('._map');

		// var _stalker_build_name = _stalker_title.getElement('._name');
		// check the building name
		// if (this.build_name === ''){
		// 	this.build_name = this.build_address;
		// 	_stalker_build_name.set('text', this.build_name);
		// } else {
		// 	// check the address
		// 	if (this.build_address === '') {
		// 		_stalker_build_name.set('text', this.build_name);
		// 	} else {
		// 		_stalker_build_name.set('text', this.build_name + ', ' + this.build_address);
		// 	}
		// }

		var buildingTypeAndHood = void 0;
		if (this.build_type != '') {
			buildingTypeAndHood = this.build_type;
		}
		if (this.map_name != '') {
			if (this.build_type != '') {
				buildingTypeAndHood += ' in ';
			}
			buildingTypeAndHood += this.map_name;
		}
		_stalker_build_type.set('text', buildingTypeAndHood);
	},

	set_off_market_deals: function set_off_market_deals() {
		var _off_market_deals = document.getElement('.w_stalker ._info .button-off-market-deals');

		if (_off_market_deals) {
			if (this.build_predev_concept == "0" && (this.build_type === 'Condo' || this.build_type === 'Co-Op' || this.build_type === 'Condop')) {
				// nothing to do
			} else {
				_off_market_deals.getParent().dispose();
			}
		}
	},

	set_available_apts: function set_available_apts() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _aval_apts = document.getElement('.w_stalker ._info ._aval_apts');

		if (apts > 0 && _aval_apts && _aval_apts.getElement('._value')) {
			_aval_apts.getElement('._value').set('text', apts);
			_aval_apts.getElement('._text').set('text', 'Available Apt' + (apts > 1 ? 's' : ''));
			_aval_apts.set('href', this.apt_sale_url);
		} else if (_aval_apts) {
			_aval_apts.getParent().dispose();
		}
	},

	set_sales_data: function set_sales_data() {
		var _sales_history = document.getElement('.w_stalker ._info ._sales_history');

		if (_sales_history && this.is_sales_history === '1') {
			_sales_history.set('href', this.sales_history_url);
		} else if (_sales_history) {
			_sales_history.getParent().dispose();
		}
	},

	set_similar_buildings: function set_similar_buildings() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _similar_buildings = document.getElement('.w_stalker ._info ._similar_buildings');

		if (_similar_buildings) {
			_similar_buildings.set('href', this.similar_buildings_url);
		} else if (_similar_buildings) {
			_similar_buildings.getParent().dispose();
		}
	},

	set_all_units: function set_all_units() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _all_units = document.getElement('.w_stalker ._info ._all_units');

		if (_all_units && this.all_units_url && this.build_predev_concept == "0") {
			_all_units.set('href', this.all_units_url);
		} else if (_all_units) {
			_all_units.getParent().dispose();
		}
	},

	// set_floorplans: function() {
	// 	var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
	// 	var _floorplans = document.getElement('.w_stalker ._info ._floorplans');

	// 	if (_floorplans && this.floorplans_url) {
	// 		_floorplans.set('href', this.floorplans_url);
	// 	} else {
	// 		_floorplans.getParent().dispose();
	// 	}
	// }, 

	set_sell: function set_sell() {
		var _sell = document.getElement('.w_stalker ._info ._sell');

		if (_sell) {
			if (_sell && this.sell_url && this.build_type !== 'No Fee Rental' && this.build_type !== 'Townhouse') {
				_sell.set('href', this.sell_url);
				Core.setBuildingSellData(_sell, this.building_total_units);
			} else {
				_sell.getParent().dispose();
			}
		}
	},

	set_contact: function set_contact() {
		var _contact = document.getElement('.w_stalker ._info .button-book-tour');

		if (_contact && this.build_type === 'No Fee Rental') {
			_contact.set('text', 'Contact');
		}
	}

});
//# sourceMappingURL=bsl.js.map
